import { useMemo } from 'react'

const VALID_ICONS = new Set([
  'architecture',
  'account_circle',
  'view_comfy_alt',
  'account_tree',
  'library_books',
  'schema',
  'terminal',
  'image_search',
  'search',
  'brush',
  'menu_book',
  'edit_document',
  'image',
  'dns',
  'cleaning_services',
  'format_quote',
  'biotech',
  'shapes',
  'web',
  'database',
  'hexagon',
  'auto_stories',
  'bar_chart',
  'picture_as_pdf',
  'arrow_forward',
  'lock',
  'construction',
  'list_alt',
  'content_copy',
  'play_arrow',
  'description',
  'code',
  'add',
  'check',
  'link',
  'check_circle',
  'signal_cellular_alt',
  'bookmark_border',
  'neurology',
  'close',
  'menu',
  'widgets',
  'build',
  'bolt',
  'science',
  'face',
  'sync_alt',
])

interface IconProps {
  name: string
  size?: number
  className?: string
  filled?: boolean
}

export function Icon({ name, size = 24, className = '', filled = false }: IconProps) {
  const validName = useMemo(() => {
    if (VALID_ICONS.has(name)) return name
    console.warn(`Unknown Material Symbols icon: ${name}`)
    return 'help'
  }, [name])

  return (
    <span
      className={`material-symbols-outlined inline-flex items-center justify-center ${className}`}
      style={{
        fontSize: size,
        width: size,
        height: size,
        fontVariationSettings: `'FILL' ${filled ? 1 : 0}, 'wght' 400, 'GRAD' 0, 'opsz' 24`,
      }}
    >
      {validName}
    </span>
  )
}
